import { InlineMessage } from '@strata/react-inline-message';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';

import {
    ProductPayerConfigUploadNotes,
    ProductPayerConfigUploadNotesWithoutPriorAuth,
} from 'pages/productConfig/ProductPayerConfigBulkUploadSupport';

export const ProductPayerConfigBulkUploadTips = ({ extraNotes = [] }) => {
    const { enableNonPaClaimsBasedIntake } = useFlags() ?? {};
    const notes = enableNonPaClaimsBasedIntake
        ? ProductPayerConfigUploadNotes
        : ProductPayerConfigUploadNotesWithoutPriorAuth;

    return [...notes, ...extraNotes].map((note) => (
        <div key={note.title} className="sds_bulk-upload__notes">
            <InlineMessage
                intent={InlineMessage.Intent.TIP}
                title={note.title}
                wrapText
                label={
                    <ul>
                        {note.notes.map((bullet) => (
                            <li key={bullet}>{bullet}</li>
                        ))}
                    </ul>
                }
            />
        </div>
    ));
};

ProductPayerConfigBulkUploadTips.propTypes = {
    extraNotes: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            notes: PropTypes.arrayOf(PropTypes.string).isRequired,
        }),
    ),
};
